import Head from 'next/head';
import React from 'react';
import { AnonymousModifyOrder } from '@common/features/account/routes/AnonymousModifyOrder';
import { entitySelectors } from '@store/entity';
import { NextPage } from 'next';
import { Property } from 'shared-types/Property';

type AmendOrderPageProps = {
  siteSlug: string;
  orderUuid: string;
  property: Property;
};

const AmendOrderPage: NextPage<AmendOrderPageProps> = ({ property, orderUuid, siteSlug }) => {
  const pageTitle = property.propertyTitle
    ? `${property.name} | ${property.propertyTitle}`
    : property.name;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>

      <AnonymousModifyOrder
        siteSlug={siteSlug}
        orderUuid={orderUuid}
        propertyUuid={property.uuid}
        propertyId={property.id}
      />
    </>
  );
};

const { getProperty } = entitySelectors;

AmendOrderPage.getInitialProps = async ({ property, query, store }) => {
  const { slug } = getProperty(store.getState());
  const orderUuid = query.orderUuid as string;

  return {
    property,
    orderUuid,
    siteSlug: slug,
  };
};

export default AmendOrderPage;
